import Vue from 'vue'
import VueApollo from 'vue-apollo'
import { ApolloClient } from 'apollo-client'
import { ApolloLink } from 'apollo-link'
import { createHttpLink } from 'apollo-link-http'
import { onError } from 'apollo-link-error'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { graphQlUrl } from '@/constants/config'
import store from '@/store'

Vue.use(VueApollo)

const httpLink = createHttpLink({
  uri: graphQlUrl
  // fetchOptions: {
  //   credentials: 'include',
  // },
})

const middlewareLink = new ApolloLink((operation, forward) => {
  if (!localStorage.token) {
    localStorage.setItem('token', '')
  }

  operation.setContext({
    headers: {
      authorization: localStorage.getItem('token')
    }
  })
  return forward(operation)
})

const errorLink = onError(({graphQLErrors, networkError}) => {
  if (networkError) {
    console.log('[networkError', networkError) // eslint-disable-line no-console
  }

  if (graphQLErrors) {
    for (const err of graphQLErrors) {
      if (err.extensions.code === 'authentication_error') {
        store.dispatch('authenticationError')
      }
    }
  }
})

const link = errorLink.concat(middlewareLink.concat(httpLink))

// Cache implementation
const cache = new InMemoryCache({
  addTypename: false
})

// Create the apollo client
export const apolloClient = new ApolloClient({
  link,
  cache
})

export const apolloProvider = new VueApollo({
  defaultClient: apolloClient
})
